import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-nav-guest',
  templateUrl: './nav-guest.component.html',
  styleUrls: ['./nav-guest.component.scss']
})
export class NavGuestComponent implements OnInit {

  @Output() hideLogin = new EventEmitter();

  constructor(
    private router: Router
  ) {
  }


  ngOnInit(): void {
  }

  handleLoggedIn() {
    this.hideLogin.emit();
  }

  goToAbout() {
    this.router.navigate(['/home'], {fragment: 'about'});
    document.querySelector('about').scrollIntoView();
  }

  goToCatalog() {
    this.router.navigate(['/home'], {fragment: 'catalog'});
    document.querySelector('catalog').scrollIntoView();
  }

  goToChannel() {
    this.router.navigate(['/home'], {fragment: 'channel'});
    document.querySelector('channel').scrollIntoView();
  }

  goToContact() {
    this.router.navigate(['/home'], {fragment: 'contact'});
    document.querySelector('contact').scrollIntoView();
  }
}
